import defaultSettings from "../settings.json";
const initialState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {}
  },
  menus: [],
  menuLoading: false
};
export default function store(state = initialState, action) {
  switch (action.type) {
    case "update-settings":
      {
        const {
          settings
        } = action.payload;
        return { ...state,
          settings
        };
      }

    case "update-userInfo":
      {
        const {
          userInfo = initialState.userInfo,
          userLoading
        } = action.payload;
        return { ...state,
          userLoading,
          userInfo
        };
      }

    case "update-menus":
      {
        const {
          menus = initialState.menus,
          menuLoading
        } = action.payload;
        return { ...state,
          menus,
          menuLoading
        };
      }

    default:
      return state;
  }
}